/**
 * Returns true if the specified element is fully visible in the modal content container.
 * @param {*} containerElement - DOM element of the surrounding container.
 * @param {HTMLElement} element - DOM element we want to check for visibility.
 */
export default function isFullyVisibleInContainer(containerElement, element) {
    if (!containerElement || !element) return false;

    const contentRect = containerElement.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    return elementRect.bottom <= contentRect.bottom;
}
